import { ReactElement } from 'react'
import { Box, Typography } from '@mui/material'
import type { ProjectFieldDTO } from '@api/fastAPI.schemas'
import { Select, TextField } from '@ui/forms'
import { customFieldName } from './utils'

interface Props {
  fields: ProjectFieldDTO[]
}

/**
 * The organisation's own project data fields (Projektdaten, defined in the global Systemmanager),
 * the form's "Erweiterte Daten" tab. All of them are required; the description is the field's
 * help text.
 */
const CustomProjectFields = ({ fields }: Props): ReactElement | null => {
  if (!fields.length) return null

  return (
    <Box data-cy="custom-project-fields">
      <Typography variant="body2" color="text.secondary" mb={2}>
        Von Ihrer Organisation festgelegte Projektdaten. Alle Felder sind Pflichtfelder.
      </Typography>
      <Box display="grid" gridTemplateColumns="repeat(2, minmax(0, 1fr))" columnGap={3} rowGap={1}>
        {fields.map(field =>
          field.field_type === 'select' ? (
            <Select
              key={field.guid}
              name={customFieldName(field)}
              label={`${field.title} *`}
              tooltip={{ text: field.description }}
              placeholder="Bitte auswählen"
              options={field.options.map(option => ({
                value: option.id ?? '',
                label: option.label,
              }))}
              data-cy={`input-custom-field-${field.template_key}`}
            />
          ) : (
            <TextField
              key={field.guid}
              name={customFieldName(field)}
              label={`${field.title} *`}
              tooltip={{ text: field.description }}
              data-cy={`input-custom-field-${field.template_key}`}
            />
          ),
        )}
      </Box>
    </Box>
  )
}

export default CustomProjectFields
